import { Icon } from "@/Common/Components/IconControls/IconControls";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./InvalidPharmacyWarningMessage.module.scss";

function InvalidPharmacyWarningMessage(): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={styles.container}>
            <Icon
                type="exclamation-circle"
                color="red"
            />
            <p>{getText("ContactDirectory_InvalidPharmacy_WarningMessage")}</p>
        </div>
    );
}

export { InvalidPharmacyWarningMessage };
